import { Box, Typography } from '@mui/material';

import MaterialReceiptsTable from './MaterialReceiptsTable';
import { MATERIAL_TABLE_TEXTS } from './materialPresentationConstants';
import { materialMoney } from '../../../utils/materialDisplay';

/**
 * Detalle de un renglón: pedidos a proveedor, recepciones y remitos.
 * @param {Object} props
 * @param {Object} props.row Renglón con `purchases` o `receipts`.
 * @returns {JSX.Element}
 */
const MaterialRowDetails = ({ row }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 1.25,
      px: { xs: 1.25, md: 2 },
      py: 1.5,
      backgroundColor: 'background.formTables',
    }}
  >
    {(row.purchases || [row]).map((purchase, index) => (
      <Box
        key={purchase.uuid || index}
        sx={{ backgroundColor: 'background.paper', overflow: 'hidden' }}
      >
        <Box sx={{ px: 1.75, py: 1 }}>
          <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 800 }}>
            {purchase.order_code} · {purchase.provider_name || MATERIAL_TABLE_TEXTS.transfer}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
            {MATERIAL_TABLE_TEXTS.original}: {materialMoney(purchase.historical_amount_ars)} ·{' '}
            {MATERIAL_TABLE_TEXTS.current}: {materialMoney(purchase.current_amount_ars)}
          </Typography>
        </Box>
        <MaterialReceiptsTable receipts={purchase.receipts} />
      </Box>
    ))}
  </Box>
);

export default MaterialRowDetails;
